import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App'
import { normalizePath, resolveRoute } from './routes'
import './styles/fonts.css'
import './styles/tailwind.css'

const container = document.getElementById('root')!
const pathname = normalizePath(window.location.pathname)

// Il chunk della pagina va caricato prima dell'idratazione, altrimenti React non troverebbe
// il markup prerenderizzato. Nel prerender i suoi <link modulepreload> sono già nell'HTML.
const { default: Page } = await resolveRoute(pathname).load()

const app = (
  <StrictMode>
    <App pathname={pathname} Page={Page} />
  </StrictMode>
)

// In produzione l'HTML è già prerenderizzato: si "idrata". In sviluppo (vite dev) non c'è.
if (container.hasChildNodes()) {
  hydrateRoot(container, app)
} else {
  createRoot(container).render(app)
}
